<div class="offerwrapper acvis-elevation" (dragover)="dragOver($event)" (drop)="dropp($event)">
    <div class="offerheader">
        <span multilang class="offerheadertext"><b>Angebot Nr. {{index()}}</b> {{title()}}</span>
        <ng-container *ngIf="currentCustomer()?.asPartner">
            <div class="actions">
                <mat-icon class="rmico mr3" (click)="setCommentModal()" matTooltip="Extra info">comment
                </mat-icon>
                <button [draggable]="true" class="drg mr3" matTooltip="Position ändern"
                    (dragstart)="dragStart($event, index())">
                    <svg _ngcontent-soh-c164="" width="24px" fill="currentColor" viewBox="0 0 24 24">
                        <path _ngcontent-soh-c164=""
                            d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z">
                        </path>
                        <path _ngcontent-soh-c164="" d="M0 0h24v24H0z" fill="none"></path>
                    </svg>
                </button>
                <mat-icon class="rmico" (click)="removeFromListF()" matTooltip="Angebot löchen">cancel
                </mat-icon>
            </div>
        </ng-container>
    </div>
    <div class="offerbody">
        <div class="offerimgwrapper">
            <imageslider (clickOnImg)="openImageModal($event)" [showcounter]="false" [current]="0"
                [data]="sktvContent()?.images" class="offerimg"></imageslider>
            <div class="bookingcardheader">
                <div class="hotelnamewrapper">
                    <span multilang>
                        <mat-icon *ngFor="let cat of categoryAr();" class="infoc">
                            {{cat === 1 ? 'star':'star_half'}}
                        </mat-icon>
                    </span>
                    <span multilang class="bold">{{sktvContent()?.name}}</span>
                    <span multilang class="locationsize">
                        {{sktvContent()?.location}}
                    </span>
                </div>
            </div>
        </div>

        <div class="offerOperator">
            <img class="lazyload" src="https://media.traffics-switch.de/vadata/logo/png/h50/sonn.png" height="24px"
                alt="sonnenklarTV">
            <span multilang style="font-weight: 500;">Sonnenklar.TV</span>
        </div>
        <div class="offerschedule">
            <mat-icon class="unsetico">event</mat-icon>
            <span multilang class="offerscheduletext">
                <b>{{offer?.travelDate?.duration + ' Nächte'}}</b>
                {{offer?.travelDate?.fromDate | date}} - {{offer?.travelDate.toDate | date}}
            </span>
        </div>
        <div class="offerinfos">
            <div class="infobody">
                <div class="offerinfodet">
                    <mat-icon class="infoc">bedroom_child</mat-icon>
                    <span multilang style="margin-left: .3rem;">{{offer?.hotelOffer?.roomType?.name}}
                        {{offer?.hotelOffer?.locatedList?.join(',')}}</span>
                </div>
                <div class="offerinfodet">
                    <mat-icon class="infoc">restaurant</mat-icon>
                    <span multilang style="margin-left: .3rem;">{{offer?.hotelOffer?.boardType?.name}}</span>
                </div>
                <ng-container *ngIf="offer?.transferOffer?.code === 'MT'">
                    <div class="offerinfodet">
                        <mat-icon class="infoc">directions_bus</mat-icon>
                        <span multilang style="margin-left: .3rem;">{{offer?.transferOffer?.description}}</span>
                    </div>
                </ng-container>
                <ng-container *ngIf="offer?.flightOffer">
                    <div class="offerinfodet">
                        <mat-icon class="infoc">{{mode() === 'railtravel' ? 'train' : 'flight'}}</mat-icon>
                        <span multilang style="margin-left: .3rem;max-width: calc(100% - 40px);" class="ellipsis">
                            {{offer?.flightOffer?.flight?.departureAirport?.name}} /
                            {{offer?.flightOffer?.flight?.arrivalAirport?.name}}
                        </span>
                        <mat-icon class="infoc flgd" style="cursor:pointer" matTooltip="Klicken für Flugdetails"
                            matTooltipClass="matTooltip" (click)="openFluginfo();">info
                        </mat-icon>
                    </div>
                </ng-container>
            </div>
            <div class="offerinfodet">
                <app-offerpackspecinfo [mode]="'pauschal'" [offer]="offer"></app-offerpackspecinfo>
            </div>
            <div class="offerinfodet" (click)="openDetail()">
                <span multilang class="minbtn noselect" matRipple>Mehr Details</span>
            </div>

        </div>
        <div class="offerprice" (click)="goToBooking()">
            <span multilang>{{travelerText}} <mat-icon class="infoc" style="cursor:help" #tooltipsofferpack="matTooltip"
                    (click)="tooltipsofferpack.toggle();$event.stopPropagation();" matTooltipClass="matTooltip"
                    [matTooltip]="prcdetail">info
                </mat-icon></span>
            <div class="offerpriceTotal">
                <span multilang>Gesamtpreis:</span>
                <span multilang class="prccolor">{{booking?.totalPrice?.value | number:'1.2-2'}}
                    {{booking?.totalPrice?.currency}}</span>
            </div>
        </div>
        <div class="mhrd">
            @if(checkloading) {
            <mat-spinner diameter="20"></mat-spinner>
            } @else {
            @if(showAlternative) {
            <button class="noselect alternativebtn" (click)="gotoOffers()">
                Ausgebucht, bitte alternative beachten
            </button>
            } @else {
            <button class="noselect bookingbtn" (click)="goToBooking()">
                Buchen
            </button>
            }
            }
        </div>
    </div>
</div>

<ng-container *ngIf="showDetail">
    <clever-offerpackdetailmodal (triggerCloseModal)="closeModal($event)"
        [cmpRef]="component"></clever-offerpackdetailmodal>
</ng-container>